module.exports = __webpack_public_path__ + "img/22.1c605c54.jpg";